/* eslint-disable no-template-curly-in-string */
/**
 * @file 编辑器扩展, 增加自定义组件
 */
import { BasePlugin, registerEditorPlugin } from 'amis-editor'

export class AimapPlugin extends BasePlugin {
  // 关联渲染器名字
  rendererName = 'aimap';
  $schema = '/schemas/UnkownSchema.json';
  notRenderFormZone = true;
  // 组件名称（组件面板显示的Title）
  name = '图炫地图';
  order=0; // 排序
  description = '图炫地图展示信息';
  tags = ['地图', 'A自定义'];
  icon = 'fa fa-file-code-o';
  scaffold = { // 插入到页面时需要
    type: 'aimap',
    isValidateSave: true,
    'amap_key': '5uLKPA8n0kzOzRsCTpkmfFtutrPD7pNT',
    // 'amap_security': 'bb44a80bc8964703b295d5a8f3f4f3ed',
    'amap_width': '100%',
    'amap_height': '500px',
    'amap_is_search': true,
    'amap_is_click': true,
    'amap_is_show_more_marker': false,
    'amap_list': 'items',
    'amap_longitude': 'longitude',
    'amap_latitude': 'latitude',
    'amap_name': 'deviceName',
    'amap_info': 'address',
    'amap_create_time': new Date().getTime(),
    'province': 'province',
    'city': 'city',
    'area': 'area',
    'township': 'township',
    'amap_is_show_window': false,
    'amap_window_dom': '<div style="padding:5px;background:#fff;border-radius:20px;width:400px;"><img style="width:100%;margin-bottom:10px;" src="${mainPic}"/></br><b>名称：${siteName} </b></br><b>地址：${address} </b></div>',
    // 'amap_is_polygon': false,
    // 'amap_is_polygon_editable': false,
    // 'amap_is_polygon_draggable': false,
    // 'amap_is_polygon_path': 'path'
    // body: {
    //   amap_name: '名称',
    //   amap_value: '10'
    // }

    // body: [ // 容器类字段
    //  {
    //    'type': 'amap',
    //    'tpl': '自定义容器区',
    //    'inline': false
    //  }
    // ]
  };
  previewSchema = { // 组件面板预览时需要
    type: 'amap',
    label: 'amap'
  };

  // 容器类组件必需字段
  // regions = [
  //   {
  //     key: 'body',
  //     label: '内容区'
  //   }
  // ];

  panelTitle = '配置'; // 右侧属性面板Title
  panelControls = [ // 右侧属性面板配置项
    {
      type: 'tabs',
      tabsMode: 'line',
      className: 'editor-prop-config-tabs',
      contentClassName: 'no-border editor-prop-config-tabs-cont hoverShowScrollBar',
      linksClassName: 'editor-prop-config-tabs-links aa',
      tabs: [
        {
          title: '常规',
          className: 'p-none',
          controls: [
            {
              'type': 'collapse-group',
              className: 'ae-formItemControl ae-styleControl',
              'activeKey': [
                'amap_11', 'amap_12'
              ],
              body: [
                {
                  'type': 'collapse',
                  'key': 'amap_11',
                  'header': '基本',
                  headingClassName: 'ae-formItemControl-header ae-Collapse-header',
                  bodyClassName: 'ae-formItemControl-body',
                  'body': [
                    {
                      type: 'input-text',
                      name: 'amap_key',
                      label: '地图key',
                      value: '5uLKPA8n0kzOzRsCTpkmfFtutrPD7pNT',
                      // 'mode': 'inline',
                      'required': true

                    },
                    // {
                    //   type: 'input-text',
                    //   name: 'amap_security',
                    //   label: '地图密钥',
                    //   value: 'f7809e471d357b7be282adb82d2f0e4b',
                    //   // 'mode': 'inline',
                    //   'required': true
                    // }
                  ]
                }
              ]
            }

          ]
        },
        {
          title: '外观',
          className: 'p-none',
          controls: [
            {
              'type': 'collapse-group',
              className: 'ae-formItemControl ae-styleControl',
              'activeKey': [
                'amap_21', 'amap_22', 'amap_23'
              ],
              'body': [
                {
                  'type': 'collapse',
                  'key': 'amap_21',
                  'header': '基本',
                  headingClassName: 'ae-formItemControl-header ae-Collapse-header',
                  bodyClassName: 'ae-formItemControl-body',
                  'body': [
                    {
                      type: 'input-text',
                      name: 'amap_width',
                      label: '宽度',
                      value: '90%'
                    },
                    {
                      type: 'input-text',
                      name: 'amap_height',
                      label: '高度',
                      value: '500px'
                    },
                    {
                      'type': 'switch',
                      'label': '是否支持搜索',
                      'option': '',
                      'name': 'amap_is_search',
                      'falseValue': false,
                      'trueValue': true,
                      'value': true,
                      'onText': '启用',
                      'offText': '禁用'
                    },
                    {
                      'type': 'switch',
                      'label': '是否支持点击',
                      'option': '',
                      'name': 'amap_is_click',
                      'falseValue': false,
                      'trueValue': true,
                      'value': true,
                      'onText': '启用',
                      'offText': '禁用'
                    }
                  ]
                },
                // {
                //   'type': 'collapse',
                //   'key': 'amap_22',
                //   'header': '多边形',
                //   headingClassName: 'ae-formItemControl-header ae-Collapse-header',
                //   bodyClassName: 'ae-formItemControl-body',
                //   'body': [
                //     {
                //       'type': 'switch',
                //       'label': '是否支持多边形',
                //       'option': '',
                //       'name': 'amap_is_polygon',
                //       'falseValue': false,
                //       'trueValue': true,
                //       'value': false,
                //       'onText': '启用',
                //       'offText': '禁用'
                //     },
                //     {
                //       'type': 'switch',
                //       'label': '当前是否可编辑',
                //       'option': '',
                //       'name': 'amap_is_polygon_editable',
                //       'falseValue': false,
                //       'trueValue': true,
                //       'value': false,
                //       'onText': '启用',
                //       'offText': '禁用',
                //       'visibleOn':'${amap_is_polygon}'
                //     },
                //     {
                //       'type': 'switch',
                //       'label': '是否可拖拽移动',
                //       'option': '',
                //       'name': 'amap_is_polygon_draggable',
                //       'falseValue': false,
                //       'trueValue': true,
                //       'value': false,
                //       'onText': '启用',
                //       'offText': '禁用',
                //       'visibleOn':'${amap_is_polygon}'
                //     },
                //     {
                //       type: 'input-text',
                //       name: 'amap_is_polygon_path',
                //       label: '多边形数据',
                //       value: 'path',
                //       visibleOn: '${amap_is_polygon}'
                //       // 'mode': 'inline'
                //     }
                //   ]
                // },
                {
                  'type': 'collapse',
                  'key': 'amap_23',
                  'header': '信息弹窗',
                  headingClassName: 'ae-formItemControl-header ae-Collapse-header',
                  bodyClassName: 'ae-formItemControl-body',
                  'body': [
                    {
                      'type': 'switch',
                      'label': '是否支持信息弹窗',
                      'option': '',
                      'name': 'amap_is_show_window',
                      'falseValue': false,
                      'trueValue': true,
                      'value': false,
                      'onText': '启用',
                      'offText': '禁用'
                    },
                    {
                      type: 'ae-textareaFormulaControl',
                      variableMode: 'tree',
                      label: '弹窗内容',
                      mode: 'normal',
                      // visibleOn: 'data.wrapperComponent !== undefined',
                      pipeIn: (value, data) => value || (data && data.html),
                      name: 'amap_window_dom',
                      tpl: '<div style="padding:5px;background:#fff;border-radius:20px;width:400px;"><img style="width:100%;margin-bottom:10px;" src="${mainPic}"/></br><b>名称：${siteName} </b></br><b>地址：${address} </b></div>'
                    }
                  ]
                },

                
              ]
            }
          ]
        },
        {
          title: '数据',
          className: 'p-none',
          controls: [
            {
              'type': 'collapse-group',
              className: 'ae-formItemControl ae-styleControl',
              'activeKey': [
                'amap_31', 'amap_32'
              ],
              'body': [
                {
                  'type': 'collapse',
                  'key': 'amap_31',
                  'header': '绑定字段',
                  headingClassName: 'ae-formItemControl-header ae-Collapse-header',
                  bodyClassName: 'ae-formItemControl-body',
                  'body': [
                    {
                      'type': 'switch',
                      'label': '是否显示多个标记点',
                      'option': '',
                      'name': 'amap_is_show_more_marker',
                      'falseValue': false,
                      'trueValue': true,
                      'value': false,
                      'onText': '启用',
                      'offText': '禁用'
                    },
                    {
                      type: 'input-text',
                      name: 'amap_list',
                      label: '数据列表',
                      value: 'items',
                      visibleOn: '${amap_is_show_more_marker}'
                      // 'mode': 'inline'
                    },
                    {
                      type: 'input-text',
                      name: 'amap_name',
                      label: '名称',
                      value: 'deviceName'
                      // 'mode': 'inline'
                    },
                    {
                      type: 'input-text',
                      name: 'province',
                      label: '省',
                      value: 'province'
                      // 'mode': 'inline'
                    },
                    {
                      type: 'input-text',
                      name: 'city',
                      label: '市',
                      value: 'city'
                      // 'mode': 'inline'
                    },
                    {
                      type: 'input-text',
                      name: 'area',
                      label: '区',
                      value: 'area'
                      // 'mode': 'inline'
                    },

                    {
                      type: 'input-text',
                      name: 'township',
                      label: '街道/乡镇',
                      value: 'township'
                      // 'mode': 'inline'
                    },
                    {
                      type: 'input-text',
                      name: 'amap_longitude',
                      label: '经度',
                      value: 'longitude'
                      // 'mode': 'inline'
                    },
                    {
                      type: 'input-text',
                      name: 'amap_latitude',
                      label: '纬度',
                      value: 'latitude'
                      // 'mode': 'inline'
                    },
                    {
                      type: 'input-text',
                      name: 'amap_info',
                      label: '地址信息',
                      value: 'address'
                      // 'mode': 'inline'
                    }

                  ]
                }
              ]
            }
          ]
        }
      ]

    }

  ];
}

registerEditorPlugin(AimapPlugin)
